import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMedia } from "./useMedia";
import { useEffect, useState } from "react";
import { useConsentService } from "@aviv-csnt/react";
import { MediaPlayer } from "./MediaPlayer";
import { ConsentLayer } from "./ConsentLayer";
export const MediaFullscreen = ({ media, consentNeeded, }) => {
    const { embedUrl } = useMedia(media);
    const { consentItems, isConsentGranted } = useConsentService();
    const [marketingConsents, setMarketingConsents] = useState(false);
    useEffect(() => {
        setMarketingConsents(Object.values(consentItems)
            .filter((item) => item.category === "marketing")
            .every((item) => item.consent === true) && isConsentGranted);
    }, [consentItems, isConsentGranted]);
    if (!embedUrl)
        return null;
    return (_jsx(_Fragment, { children: marketingConsents || !consentNeeded ? (_jsx(MediaPlayer, { embedUrl: embedUrl })) : (_jsx(ConsentLayer, { media: media })) }));
};
